import { getSemanticVersion } from "./utils";

export const enum EVENT_TAGS {
  LINK = "link",
  REDIRECT = "redirect",
  ANALYTICS = "analytics",
}

export const enum CLIENT {
  LINKT = "linkt",
  LINKTGO = "linktgo",
}

export const enum REGION {
  NSW = "nsw",
  QLD = "qld",
  VIC = "vic",
}

export const enum REWARD_OFFERING {
  SHELL = "rewards-shell-express",
  seveneleven = "7-eleven",
  sevenelevtactical = "tactical-7-eleven",
  shellfuelup = "fuel-up-your-savings",
  bcf = "bcf",
  bridgetobrisbane = "bridge-to-brisbane",
  bridgetobrisbanetactical = "bridge-to-brisbane-tactical",
  comingsoonfuel = "coming-soon-fuel",
  europcar = "europcar",
  europcartactical = "europcar-tactical",
  europcartactical2 = "europcar-tactical-2",
  europcartactical3 = "europcar-tactical-3",
  starcarwash = "star-car-wash",
  starcarwashtactical = "star-car-wash-tactical",
  starcarwashtactical2 = "star-car-wash-tactical-2",
  bookingdotcom = "booking-dot-com",
  carepark = "care-park",
  comp1000prizes = "comp-1000-prizes",
  compwinchoosefly = "comp-winchoosefly",
  secureparking = "secure-parking",
  mycar = "mycar",
  mycartactical = "mycar-tactical",
  globalescapes = "global-escapes",
  runforkids = "run-for-kids",
  originenergy = "origin-energy",
  supercheapauto = "supercheap-auto",
  supercheapautotactical1 = "supercheap-auto-tactical-1",
  supercheapautotactical2 = "supercheap-auto-tactical-2",
  supercheapautotactical3 = "supercheap-auto-tactical-3",
  totaltools = "total-tools",
  sydneyairport = "sydney-airport",
  sydneyairporttactical = "sydney-airport-tactical",
  sydneyMarathon = "sydney-marathon",
  summerGiveawayExtra = "summerGiveawayExtra",
  tourdebrisbane = "tour-de-brisbane",
  weekone = "week-one",
  weektwo = "week-two",
  weekthree = "week-three",
  weekfour = "week-four",
  wgtextra = "wgt-extra",
  wgt1 = "wgt-1",
  wgt2 = "wgt-2",
  wgt3 = "wgt-3",
  wgt4 = "wgt-4",
  easterGiveawayExtra = "easter-giveaway-extra",
  tripComCompetition = "trip-com-competition",
  tripCom = "trip-com",
  sydneyMarathon42km = "sydney-marathon-42km",
  sydneyMarathon5km = "sydney-marathon-5km",
}

export const enum COUPON_OFFERS {
  bcf = "bcf-1x0x1",
  supercheapauto = "supercheap-auto-1x0x2",
  supercheapautotactical1 = "supercheap-auto-tactical-1-1x0x1",
  supercheapautotactical2 = "supercheap-auto-tactical-2-1x0x1",
  supercheapautotactical3 = "supercheap-auto-tactical-3-1x0x1",
  totaltools = "total-tools-1x0x0",
  globalescapes = "global-escapes-1x0x0",
  runforkids = "run-for-kids-1x0x1",
  sydneyairport = "sydney-airport-1x0x0",
  sydneyairporttactical = "sydney-airport-1x0x7",
  bridgetobrisbane = "bridge-to-brisbane-1x0x0",
}

export const enum PLATFORM {
  ANDROID = "android",
  IOS = "ios",
}

export const ANALYTICS_CLIENT_ID_MAP: { [key: string]: string } = {
  linktgo: "LG",
  linkt: "LA",
};

export const enum FLOW {
  ONBOARDING = "onboarding",
  REDEEM = "redeem",
  PENDING = "loading",
}

// The minimum app version that supports the close app callback.
export const CLOSE_FULLSCREEN_CALLBACK_MIN_VERSION = "4.15.0";

// Setup global constants
// eslint-disable-next-line no-restricted-globals
const queryParams = new URLSearchParams(location.search);
const dataString = sessionStorage.getItem("data"); // Get data object which is injected by the app.
const client = queryParams.get("client") as CLIENT;
export const GLOBAL_CONST = {
  REWARDS_ID: REWARD_OFFERING.SHELL,
  CLIENT_ID: client,
  PLATFORM: (queryParams.get("platform") as PLATFORM) ?? PLATFORM.ANDROID,
  FLOW_PENDING: FLOW.PENDING, // Default atom store value.
  FLOW: queryParams.get("flow") ?? FLOW.ONBOARDING, // Default after assets are loaded, and flow not explicitly specified by client.
  APP_VERSION: getSemanticVersion(queryParams.get("appVersion")),
  REGION: (queryParams.get("region") as REGION) ?? REGION.NSW,
  ANALYTICS_CLIENT: ANALYTICS_CLIENT_ID_MAP[client],
  ACCESS_TOKEN: sessionStorage.getItem("rewardsToken"), // Get access token which is injected by the app.
  DATA: dataString ? JSON.parse(dataString) : ({} as { [key: string]: string }),
};

export const PLACEHOLDER_BARCODE = "00000000000000000000";
